(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novale-storefront"] && !Shopify.designMode) return;
  try {
    
  (()=>{const metaPixelId='3803547123119070';const ensureMetaPixel=()=>{if(!window.fbq){const fbq=function(){fbq.callMethod?fbq.callMethod.apply(fbq,arguments):fbq.queue.push(arguments)};window._fbq=window._fbq||fbq;fbq.push=fbq;fbq.loaded=true;fbq.version='2.0';fbq.queue=[];window.fbq=fbq;const script=document.createElement('script');script.async=true;script.src='https://connect.facebook.net/en_US/fbevents.js';const firstScript=document.getElementsByTagName('script')[0];firstScript.parentNode.insertBefore(script,firstScript);}if(!window.__novaleMetaPixelInitialized){window.fbq('init',metaPixelId);window.__novaleMetaPixelInitialized=true;}};const fireAddToCart=input=>{ensureMetaPixel();window.fbq('trackSingle',metaPixelId,'AddToCart',{content_ids:[input.dataset.variantId||input.value],content_type:'product',contents:[{id:input.dataset.variantId||input.value,quantity:1}],currency:input.dataset.currency||'USD',value:Number(input.dataset.priceAmount||0)});};document.querySelectorAll('[data-novale-section]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const form=section.querySelector('.nv__form');if(!form)return;const button=form.querySelector('.nv__cta--buy');const label=button?.querySelector('.nv__cta-label');const price=button?.querySelector('.nv__cta-price');const status=section.querySelector('.nv__shipping');const floating=section.querySelector('[data-nv-floating-buy]');const floatingButton=section.querySelector('[data-nv-floating-submit]');const floatingPrice=section.querySelector('[data-nv-floating-price]');const floatingChoice=section.querySelector('[data-nv-floating-choice]');const updateSelection=input=>{if(price&&input.dataset.price)price.textContent=input.dataset.price;if(floatingPrice&&input.dataset.price)floatingPrice.textContent=input.dataset.price;const choice=input.closest('.nv__bundle')?.querySelector('.nv__bundle-copy strong')?.textContent.trim();if(floatingChoice&&choice)floatingChoice.textContent=choice;};form.querySelectorAll('input[name="id"]').forEach(input=>input.addEventListener('change',()=>updateSelection(input)));const checked=form.querySelector('input[name="id"]:checked');if(checked)updateSelection(checked);if(floating){floating.hidden=false;let scheduled=false;const updateFloating=()=>{scheduled=false;const passed=form.getBoundingClientRect().bottom<=0;floating.classList.toggle('is-visible',passed);floating.setAttribute('aria-hidden',passed?'false':'true');};const scheduleFloating=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(updateFloating);};updateFloating();addEventListener('scroll',scheduleFloating,{passive:true});addEventListener('resize',scheduleFloating,{passive:true});}floatingButton?.addEventListener('click',()=>form.requestSubmit());form.addEventListener('submit',async event=>{event.preventDefault();if(!button||button.disabled)return;const original=label?.textContent.trim();button.disabled=true;if(floatingButton)floatingButton.disabled=true;button.classList.add('is-loading');if(label)label.textContent=button.dataset.loadingLabel;try{const response=await fetch(`${form.action}.js`,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});if(!response.ok){const payload=await response.json().catch(()=>({}));throw new Error(payload.description||'This package could not be added.');}const selected=form.querySelector('input[name="id"]:checked');if(selected)fireAddToCart(selected);await new Promise(resolve=>setTimeout(resolve,180));const root=window.Shopify?.routes?.root||'/';window.location.assign(`${root}checkout`);}catch(error){button.disabled=false;if(floatingButton)floatingButton.disabled=false;button.classList.remove('is-loading');if(label&&original)label.textContent=original;if(status)status.textContent=error.message;}});})})();

  } catch(e) { console.error(e); }
})();
})();
